import url_acc from '@/urls/accounts'
import { getUserUid } from '@/helper'
import { sendGetRequest, sendPostRequest, sendPutRequest, updateFileRequest } from '@/helper/requests'
import address from "@/store/modules/users/address"
import email from "@/store/modules/users/email"
import phone from "@/store/modules/users/phone"
import language from "@/store/modules/users/language"
import session from "@/store/modules/users/session"
import account from "@/store/modules/users/account"

const state = {
  user: {
    profile: null
  }
}
const getters = {
  getProfile: state => state.user.profile
}

const mutations = {
  SET_USER_PROFILE: (state, value) => {
    /**
     * Устанавливает профиль пользователя
     * @param {Object} state - состояние хранилища
     * @param {Object} value - данные профиля пользователя
     */
    state.user.profile = value
  }
}

const actions = {
  loadAccountDetail: ({ commit }, { finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Загружает детальную информацию об аккаунте пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.DETAIL(getUserUid())
    sendGetRequest(
      url, (data, url) => {
        commit('SET_USER_PROFILE', data)
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  changeAvatar: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Изменяет аватар пользователя
     * @param {Object} commit - контекст Vuex
     * @param {FormData} data - данные аватара
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.CHANGE_AVATAR(getUserUid())
    updateFileRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  changeEmail: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Изменяет почту пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - новые данные почты
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.CHANGE_EMAIL(getUserUid())
    sendPutRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  changePass: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Изменяет пароль пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - новые данные пароля
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.CHANGE_PASS(getUserUid())
    sendPutRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  approveEmail: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Подтверждает почту пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} data - данные для подтверждения
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = url_acc.PROFILE.APPROVE_EMAIL()
    sendPostRequest(
      url, data, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  checkUserConfirmation: ({ commit, dispatch }, { data, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Проверяет необходимость ознакомления с документами
     * @param {Object} commit - контекст Vuex
     * @param {Object} dispatch - контекст Vuex
     * @param {Object} data - дополнительные данные
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    const url = `${process.env.VUE_APP_API_HOST + process.env.VUE_APP_CONFIRMATION_PREFIX}user/document/need/acquaintance/`
    sendGetRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  checkUserSurvey: ({ commit, dispatch }, { id, special_link_key, finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Проверяет статус опроса пользователя
     * @param {Object} commit - контекст Vuex
     * @param {Object} dispatch - контекст Vuex
     * @param {string|number} id - идентификатор опроса
     * @param {string|null} special_link_key - специальный ключ ссылки
     * @param {Function} finalizer - функция обратного вызова при успехе
     * @param {Function} catcher - функция обратного вызова при ошибке
     */
    let url = `${process.env.VUE_APP_API_HOST + process.env.VUE_APP_SURVEY_PREFIX}surveying/survey/${id}/attempt_check/`
    if (special_link_key) {
      url = url + '?special_link_key=' + special_link_key
    }
    sendGetRequest(
      url, (data, url) => {
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules: {
    address,
    email,
    phone,
    language,
    session,
    account
  }
}
